// i18n area 'cluster' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.lv-LV.meta.json.
import type { enUS } from './cluster'

export const lvLV: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantijas piekļuves',
      subtitle: 'Mezgla servisa durvis: tikai lasāmā piekļuve ar pagaidu paroli un ārkārtas konts ar seifa paroli',
      readOnlyTitle: 'Tikai lasāmā piekļuve (trantor)',
      stateNone: 'slēgta',
      stateGranted: 'atvērta',
      stateGrantedPending: 'piešķirta — tiek lietota mezglā',
      grantedBy: 'Piešķīra',
      grantedAt: 'Piešķirta',
      expiresAt: 'Beidzas',
      reason: 'Iemesls',
      endedAt: 'Slēgta',
      endedReason: {
        revoked: 'atsaukta',
        expired: 'beigusies (TTL)',
        reboot: 'mezgla restartēšana',
        failed: 'nav lietota (uzdevums neizdevās)'
      },
      grant: 'Piešķirt tikai lasāmo piekļuvi…',
      grantTitle: 'Piešķirt tikai lasāmo piekļuvi',
      grantSubmit: 'Piešķirt',
      grantError: 'Piešķiršana tika noraidīta',
      grantConfirm: 'TVirt ģenerē pagaidu paroli sistēmas lietotājam «trantor» (tikai lasīšana: journal un diagnostika, bez sudo) un iestata to mezglā ar uzdevumu. Parole tiek parādīta TIKAI vienreiz, apstiprinot; tā beidzas termiņā, atsaucot vai nākamajā mezgla restartā.',
      reasonLabel: 'Iemesls',
      reasonHint: 'Kāpēc atverat durvis: tas paliek piešķīrumā, auditā un žurnālā',
      ttlLabel: 'Ilgums',
      ttlHours: '{n} h',
      revoke: 'Atsaukt tikai lasāmo piekļuvi…',
      revokeTitle: 'Atsaukt tikai lasāmo piekļuvi',
      revokeSubmit: 'Atsaukt',
      revokeError: 'Atsaukšana tika noraidīta',
      revokeConfirm: 'Piešķīrums beidzas tūlīt, un uzdevums atkal bloķē lietotāju «trantor» mezglā: pagaidu parole vairs nedarbojas.',
      passwordTitle: 'Tikai lasāmā parole',
      passwordOnce: 'Šī parole tiek parādīta TIKAI vienreiz: nokopējiet to tagad. Tā nekur netiek saglabāta un to nevarēs nolasīt atkārtoti — ja to pazaudējat, piešķiriet vēlreiz.',
      passwordUser: 'Lietotājs',
      passwordLabel: 'Parole',
      passwordHint: 'Derīga līdz {until} vai līdz nākamajam mezgla restartam; lietojama, kad piešķiršanas uzdevums ir pabeigts. Piekļuve: ssh trantor@<mezgla adrese>.',
      emergencyTitle: 'Pēdējā ārkārtas piekļuve (trantor-emergency)',
      lastLogin: '{time} caur {via} no {from}',
      lastLoginNone: 'nav novērota',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsole',
        sudo: 'sudo',
        unknown: 'nezināms'
      },
      emergencyHint: 'Ārkārtas konts «trantor-emergency» (pilns sudo) vienmēr ir iespējots ar paroli, kas ģenerēta mezgla instalēšanas laikā un glabājas seifā: TVirt to nezina, nerotē un neatjauno. Katra pieteikšanās tiek ziņota šeit un notikumu žurnālā.'
    },
    nodeFirewall: {
      tab: 'Ugunsmūris',
      title: 'Mezglu ugunsmūris',
      subtitle: 'nftables ruleset nostāja, ko katrs mezgls piemēro pats sev — vienīgais mezgla ugunsmūris (firewalld ir atspējots)',
      modeLabel: 'Nostāja',
      mode: {
        disabled: 'Atspējota — mezglos nav neviena ruleset',
        permissive: 'Pielaidīga — skaita un reģistrē, neko neatmet',
        enforced: 'Piemērota — iekšā tiek tikai atvasinātais reģistrs'
      },
      hint: {
        disabled: 'Kā šodien: mezgli nenes nevienu ruleset. Pārslēdz uz pielaidīgo, lai IZLASĪTU, kas tiktu atmests, pirms tas tiek atmests.',
        permissive: 'Katrs mezgls piemēro savu atvasināto ruleset ar policy accept: tas, ko piemērotā nostāja atmestu, tiek skaitīts un reģistrēts (journal prefikss „tvirt-node would-drop:“). Nekas netiek bloķēts.',
        enforced: 'Katrs mezgls piemēro savu atvasināto ruleset ar policy drop: ssh un API no jebkurienes, store / live migration / overlay / Ceph tikai no dalībniekiem, tīkla pakalpojumu listener no apkalpotā tīkla. Katra pārslēgšana ir apply ar apstiprinājumu — mezgls, kas nespēj apstiprināt, pats atgriežas atpakaļ.'
      },
      confirmTitle: 'Piemērot mezglu ugunsmūri?',
      confirmBody: 'Katrs mezgls piemēro ruleset ar apstiprinājumu: līdz termiņam caur jaunajiem noteikumiem zondē backend, store un ssh un apstiprina — citādi pats atgriežas pie iepriekšējā ruleset. Vispirms izlasi pielaidīgās nostājas skaitītājus mezglos.',
      confirmSubmit: 'Piemērot',
      confirmCancel: 'Atcelt',
      lensTitle: 'Mezgla ugunsmūris',
      loadError: 'Neizdevās ielādēt mezgla ugunsmūra lēcu',
      noReport: 'No šī mezgla vēl nav ugunsmūra ziņojuma — worker ziņos nākamajā passā',
      firewalldActive: 'Šajā mezglā darbojas firewalld: mezgla ugunsmūris atsakās piemēroties tam blakus (uzliec firewalld mask)',
      conditionUnconfirmed: 'Vēl nav apstiprināta ruleset — mezgls ir atvērts',
      conditionRolledBack: 'Pēdējais apply atgriezās atpakaļ — tā pati paaudze netiek mēģināta atkārtoti, kamēr nemainās reģistrs vai nostāja netiek pārslēgta vēlreiz',
      lastError: 'Pēdējā kļūda',
      posture: 'Nostāja',
      observedAt: 'Novērots',
      desiredGeneration: 'Vēlamā paaudze',
      componentTitle: 'Mezgla komponente',
      componentSubtitle: 'tvirt-node-firewall — sāknējot piemēro apstiprināto ruleset, neapstiprinātu pats atgriež atpakaļ',
      componentAbsent: 'Komponente vēl nav ziņojusi',
      phase: 'Fāze',
      phases: {
        none: 'Nekad nav piemērots',
        applied: 'Piemērots — gaida apstiprinājumu',
        confirmed: 'Apstiprināts',
        rolledBack: 'Atgriezts atpakaļ'
      },
      generation: 'Paaudze',
      appliedAt: 'Piemērots',
      confirmedAt: 'Apstiprināts',
      deadline: 'Rollback termiņš',
      lastRollback: 'Pēdējais rollback',
      registryTitle: 'Atvasinātais reģistrs',
      registrySubtitle: 'Porti, ko šis mezgls atver, pēc klases un izcelsmes — atvasināti no klastera, nekad nav rediģēti ar roku',
      registryEmpty: 'Nekas nav atvasināts — nostāja atspējota bez apstiprināta ruleset vai vēl nav ziņojuma',
      colClass: 'Klase',
      colPort: 'Ports',
      colSource: 'Avots',
      colOrigin: 'Izcelsme',
      classes: {
        public: 'Publiska',
        internode: 'Starp mezgliem',
        tenant: 'Tenant'
      },
      sourceMembers: 'tikai dalībnieki',
      sourceAnywhere: 'no jebkurienes',
      sourceBridge: 'uz {iface}'
    },
    derivationDerived: 'atvasināts',
    derivationDiverged: 'novirzījies',
    derivationDerivedTip: 'Tīkla dokuments ir ATVASINĀTS no fabric {fabric} un vēl sakrīt ar renderu uz pašreizējām ieejām — klikšķis derivācijas plānam.',
    derivationDivergedTip: 'Derivācija no fabric {fabric} mainījās pēc pēdējā apply (fabric, kabeļi, lomas vai atsauces) — klikšķis gaidošajam diff.',
    derivationRetiring: {
      zero: '{n} adrešu iztukšojas',
      one: '{n} adrese iztukšojas',
      other: '{n} adreses iztukšojas'
    },
    standaloneHint: 'Šim mezglam nav klastera: tas vēl nav instalēts. Klasterus izveido VAI tiem pievienojas instalēšanas laikā — token, kas ģenerēts kāda dalībnieka tabulā Serveri, jāpadod instalatoram (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Tavas atļaujas aptver scope, nevis visu klasteri: parka inventārs — mezgli, iestatījumi un ierīces — ir redzams tikai klastera administratoriem.',
    phaseReady: 'Gatavs',
    phaseForming: 'Notiek veidošana',
    storeMembers: 'Store dalībnieki',
    watermark: 'Konverģences slieksnis',
    configGeneration: 'Konfigurācijas paaudze',
    converged: 'saskaņots',
    behind: 'atpaliek — {m} / {n}',
    revision: 'Revīzija',
    rolesTitle: 'Tīkla lomas',
    rolesSubtitle: 'Adreses katram dalībniekam katrā satiksmes klasē — savienojamība mīt hosta tīklā',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'pārmanto management',
    settingsTitle: 'Iestatījumi',
    settingsSubtitle: 'Drošības politika klastera līmenī — katrs mezgls to izvērtē no savas lokālās replikas',
    taskRetentionTitle: 'Task glabāšana',
    taskRetentionSubtitle: 'Vienots GC visiem task — pabeigtie task, kas pārsniedz vecumu vai griestus, tiek savākti, izpildē esošie nekad',
    taskRetentionMaxAge: 'Maksimālais vecums (dienās)',
    taskRetentionMaxCount: 'Maksimālais task skaits',
    eventRetentionTitle: 'Notikumu glabāšana',
    eventRetentionSubtitle: 'Žurnāla GC — no uzdevumiem neatkarīga politika: uzdevums ir rinda, notikums ir atmiņa',
    eventRetentionMaxAge: 'Maksimālais vecums (dienas)',
    eventRetentionMaxCount: 'Maksimālais glabāto notikumu skaits',
    spaceThresholdsTitle: 'Vietas sliekšņi',
    spaceThresholdsSubtitle: 'Kad krātuve, kas pildās, nonāk žurnālā (un paziņojumos)',
    spaceLowPct: 'Brīdinājums no (% izmantots)',
    spaceCriticalPct: 'Kritisks no (% izmantots)',
    spaceOrderError: 'Kritiskais nevar būt zem brīdinājuma',
    spaceThresholdsHint: 'Konfigurē tikai ieejas: izeju atvasina dzinējs, 5 punktus zem katra sliekšņa, lai krātuve uz līnijas nekad nekļūtu par metronomu',
    failoverReserveTitle: 'Failover rezerve',
    failoverReserveSubtitle: 'Admission control N+1 — RAM, kas paturēta brīva, lai klasteris pēc mezglu zuduma varētu pārstartēt savu slodzi',
    failoverReserveTolerate: 'Mezglu skaits, kuru zudumu pieļaut',
    failoverReserveOff: '0 — rezerve izslēgta: neviena startēšana nekad netiek atteikta failover kapacitātes dēļ',
    failoverReserveOn: 'Startēšana, kas iekostu rezervē, tiek atteikta ar 412, kas paskaidro skaitļus',
    networkShapingTitle: 'Joslas platuma taisnīgums',
    networkShapingSubtitle: 'Trīs katra uplink shaping koka tipoloģiskie svari — darbojas tikai sacensības apstākļos',
    networkShapingRest: 'Pārējā svars (vadības slānis, storage, replikas)',
    networkShapingOverlay: 'Overlay tīklu svars',
    networkShapingLiveMigration: 'Live migration svars',
    networkShapingHint: 'Garantētā daļa = svars / triju summa (noklusējums 300 / 100 / 200, katrs no 1 līdz 10000); brīvā saitē jebkura klase var paņemt visu joslas platumu',
    debugModeTitle: 'Debug režīms',
    debugModeSubtitle:
      'Detalizētas kļūdas GUI vispārīgajos brīdinājumos — lai redzētu patieso cēloni, kad darbība, kas „neizdevās“, patiesībā ir izdevusies',
    debugModeLabel: 'Debug režīms iespējots',
    debugModeOn: 'Vispārīgie kļūdu brīdinājumi pievieno pamatā esošo cēloni — iekšējās detaļas redzamas katram operatoram',
    debugModeOffHint: 'Izslēgts — vispārīgie kļūdu brīdinājumi paliek vispārīgi, bez iekšējām detaļām',
    nodeDetailsAction: 'Mezgla detaļas',
    node: {
      docTitle: 'Mezgls',
      notFound: 'Mezgls nav atrasts',
      tabOverview: 'Pārskats',
      tabStats: 'Statistika',
      tabNetwork: 'Tīkls',
      tabSettings: 'Lokālie iestatījumi',
      identityTitle: 'Identitāte',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL ports',
      revision: 'Konfigurācijas revīzija',
      versionsTitle: 'Novērotās versijas',
      heartbeatSubtitle: 'Pēdējais stāvoklis, ko mezgls paziņojis pats par sevi',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU modelis',
      memoryTitle: 'Atmiņa',
      hugePagesTitle: 'Milzu lapas',
      hugePagesPool: '{size}: {free} brīvas no {total}',
      hugePagesNone: 'Nav pūla',
      hugePagesNoneHint: 'Mezglam nav rezervētu milzu lapu: VM, kas tās pieprasa, šeit nevar startēt. Pūlu deklarē uz mezgla ar kodola parametriem hugepagesz un hugepages vai ierakstot nr_hugepages.',
      usageTitle: 'Pašreizējais lietojums',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nav novērots — nav neviena svaiga parauga',
      statsNoData: 'Intervālā nav datu — mezgla laikrindas paraugo pats mezgls, un tās tiek pasniegtas lokāli.',
      observedTitle: 'Novērotais stāvoklis',
      observedSubtitle: 'Mezglam lokālie pakalpojumi un resursi, kā tos redz worker'
    },
    editRolesTitle: 'Rediģēt tīkla lomas',
    memberNode: 'Mezgls',
    memberIp: 'IP adrese',
    addMember: 'Pievienot dalībnieku',
    lmInherit: 'Lietot management adreses',
    roleIpHint: 'Dalībniekus var brīvi pievienot un noņemt; esoša dalībnieka IP maiņa uz vietas tiek atteikta — IP migrācijas plūsma ienāks nākamajā kārtā.',
    roleError: 'Neizdevās atjaunināt lomas',
    nodesTitle: 'Mezgli',
    addNodeTitle: 'Pievienot mezglu klasterim',
    addNode: 'Pievienot mezglu',
    addNodeError: 'Neizdevās iepriekš reģistrēt mezglu',
    nodeName: 'Mezgla nosaukums',
    nodeNameHint: 'jāsakrīt ar nosaukumu, kas izvēlēts instalēšanas laikā',
    nodeIp: 'Management IP',
    colName: 'Nosaukums',
    colPhase: 'Fāze',
    colServices: 'Pakalpojumi',
    colWatermark: 'Watermark',
    colLastSeen: 'Pēdējais kontakts',
    colUps: 'UPS',
    upsCordonChip: 'UPS kordons',
    upsCordonTip: 'Mezgls sevi notiesāja pēc sava UPS faktiem ({time}): tas pats noņem kordonu, kad tīkls ir stabils un akumulators uzlādēts',
    upsUnreachable: 'UPS nav sasniedzams',
    upsOnBattery: 'No akumulatora',
    upsOnLine: 'No tīkla',
    upsLowBattery: 'zems akumulatora līmenis',
    upsNoEstimateChip: 'darbības laiks nav novērtēts',
    upsNoEstimateTip: 'UPS nepublicē darbības laika novērtējumu: mezgls tiek notiesāts tikai ar UPS LB (zems akumulators) karogu — iestatiet battery.runtime.low / LB pašā UPS',
    upsLaneTip: 'UPS izslēgšanas ceļš kopš {since}: notiesāts ar {by}',
    upsUnit: 'vienība',
    upsStatus: 'NUT stāvoklis',
    upsLoad: 'slodze',
    upsOnBatterySince: 'no akumulatora kopš',
    upsOnLineSince: 'no tīkla kopš',
    upsError: 'kļūda',
    upsObservedAt: 'novērots',
    upsNone: 'neviena UPS vienība neapkalpo šo mezglu',
    upsBy: {
      runtime: 'darbības laiks zem sliekšņa',
      lowBattery: 'UPS LB karogs',
    },
    upsLane: {
      evacuate: 'evakuācija',
      local: 'izslēgšana uz vietas',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'viesu apturēšana',
      stoppingServices: 'pakalpojumu apturēšana',
      poweredOff: 'izslēgts',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS vienības un sliekšņi: mezgls notiesāts pie darbības laika ≤ slieksnis vai LB karoga (vienmēr ievērots), atsākšana ar histerēzi',
    upsRuntimeThreshold: 'Darbības laika slieksnis (s)',
    upsRuntimeThresholdHint: 'No akumulatora ar novērtēto darbības laiku ≤ slieksnis mezgls izslēdzas pēc kārtas (noklusējums 300)',
    upsResumeStable: 'Tīkls stabils (s)',
    upsResumeStableHint: 'Atsākšana tikai ar nepārtrauktu tīklu vismaz tik sekundes (noklusējums 60)',
    upsResumeCharge: 'Minimālais uzlādes līmenis atsākot (%)',
    upsResumeChargeHint: 'Un akumulators uzlādēts vismaz līdz šim procentam (noklusējums 25)',
    upsPolicyNote: 'UPS LB (zems akumulators) karogs vienmēr notiesā un nav atslēdzams; sliekšņa laikam no akumulatora nav. Katra vienība var pārrakstīt trīs skaitļus.',
    upsUnitNew: 'jauna vienība',
    upsUnitSelectors: '{n} tagu atlasītājs(-i) (tikai CLI)',
    upsUnitName: 'Vienības nosaukums',
    upsUnitMode: 'Režīms',
    upsModeExternal: 'ārēja (svešs upsd)',
    upsModeManaged: 'pārvaldīta (UPS pievienots mezglam)',
    upsUnitUpsname: 'NUT nosaukums (upsname)',
    upsUnitHost: 'upsd resursdators',
    upsUnitAttachedNode: 'Pievienotais mezgls',
    upsUnitDriver: 'NUT draiveris',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Draivera ierīce',
    upsUnitDeviceHint: 'ups.conf rinda port=: tukšs = auto',
    upsUnitPort: 'upsd ports',
    upsUnitServedNodes: 'Apkalpotie mezgli',
    upsUnitServedNodesHint: 'mezglu nosaukumi, atdalīti ar komatiem (tagu atlasītāji iet caur CLI)',
    upsUnitOverrideHint: 'tukšs = klastera noklusējums',
    upsUnitAdd: 'Pievienot vienību',
    unreachableSince: 'Nesasniedzams — pēdējais heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane vēl nav realizējis pašreizējo overlay konfigurāciju',
    overlaysError: 'Pēdējais overlay saskaņošanas cikls neizdevās: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Gaida pievienošanos',
      'joining': 'Pievienojas',
      'member': 'Dalībnieks'
    },
    tokenTitle: 'Pievienošanās token',
    tokenOnce: 'Parādīts tikai tagad — jākopē uzreiz, vairs nebūs nolasāms',
    copy: 'Kopēt',
    copied: 'Nokopēts',
    close: 'Aizvērt',
    revokeTitle: 'Atsaukt iepriekšēju reģistrāciju',
    revoke: 'Atsaukt',
    revokeError: 'Neizdevās atsaukt reģistrāciju',
    promote: 'Paaugstināt par store dalībnieku',
    demote: 'Noņemt store-member lomu',
    troubleshoot: 'Problēmu novēršana',
    promoteTitle: 'Paaugstināt par store dalībnieku',
    demoteTitle: 'Noņemt store-member lomu',
    promoteHint: 'Mezgls iestājas YugabyteDB masteru kvorumā. Īstai HA nepieciešami trīs store dalībnieki.',
    demoteHint: 'Mezgls iziet no masteru kvoruma un aptur savus store pakalpojumus.',
    storeError: 'Store-member izmaiņa tika noraidīta',
    attest: 'Apliecināt izslēgtu…',
    attestTitle: 'Apliecināt mezglu par izslēgtu',
    attestSubmit: 'Apliecināt izslēgtu',
    attestConfirm: 'Šis mezgls tiek pasludināts par izslēgtu uz jūsu paša atbildību: patiesībā dzīva mezgla apliecināšana rada risku, ka VM darbosies divkārt. Tā task tiek atzīmēti kā neizdevušies, un tā VM authority kļūst pārnesamas.',
    attestError: 'Apliecinājums tika noraidīts',
    attestedChip: 'apliecināts izslēgts',
    maintenanceChip: 'apkope',
    guestToolsChip: 'TVirt Guest Tools (mezglam lokāls ISO resurss)',
    maintenanceEnter: 'Ieslēgt apkopi',
    maintenanceExit: 'Izslēgt apkopi',
    maintenanceEnterTitle: 'Ieslēgt apkopi',
    maintenanceExitTitle: 'Izslēgt apkopi',
    maintenanceEnterSubmit: 'Ieslēgt apkopi',
    maintenanceExitSubmit: 'Izslēgt apkopi',
    maintenanceEnterConfirm: 'Mezgls tiek norobežots un iztukšots: tīkla pakalpojumi un App instances, kuru authority tas tur, tiek pārnesti (instances auksti: šeit apturētas un nopļautas, mērķa mezglā izveidotas no jauna — dīkstāve), darbojošās VM tiek migrētas dzīvajā, kur iespējams, citādi apturētas korekti, notiekošie uzdevumi tiek pabeigti, jauns darbs gaida, un apturētās VM zaudē savu authority — Proximity tās izvieto no jauna nākamajā palaišanā. Apkopes beigās nekas neatgriežas pats.',
    maintenanceExitConfirm: 'Mezgls atsāk darbu, un Proximity to atkal ņem vērā izvietošanai. VM atgriežas tikai tad, kad tiek startētas.',
    maintenanceError: 'Apkopes pieprasījums tika noraidīts',
    maintenancePlanTitle: 'Evakuācijas plāns',
    maintenancePlanLoading: 'Notiek evakuācijas plāna aprēķins…',
    maintenancePlanError: 'Neizdevās ielādēt evakuācijas plānu — iztukšošana tik un tā migrēs, kur iespējams, un pārējo apturēs.',
    maintenancePlanEmpty: 'Šajā mezglā nav ko evakuēt — nav aktīva tīkla pakalpojuma, nav darbībai vēlamas App instances, nav darbojošās VM.',
    maintenancePlanSummary: '{migrate} objekti migrēs (VM, tīkla pakalpojumi, App instances), {stop} apstāsies vai paliks, kur ir.',
    maintenancePlanReserve_ok: 'Failover rezerve pēc iztukšošanas: neskarta — paliek {headroom} GiB, ko var startēt, pieļaujot {n} mezgla(-u) zudumu.',
    maintenancePlanReserve_eroded: 'Failover rezerve pēc iztukšošanas: gandrīz izsmelta — no {reserve} GiB, kas paturēti brīvi {n} mezgla(-u) atteicei, paliek tikai {headroom} GiB.',
    maintenancePlanReserve_exhausted: 'Failover rezerve pēc iztukšošanas: IZSMELTA — trūkst {headroom} GiB no {reserve} GiB, kas nepieciešami, lai pieļautu {n} mezgla(-u) atteici. Kamēr šis mezgls ir ārpusē, jaunas VM startēšanas tiks atteiktas.',
    maintenancePlanReserve_unknown: 'Failover rezerve pēc iztukšošanas: nav aprēķināma — neviens atlikušais mezgls nav paziņojis savu atmiņu.',
    maintenancePlanReserveHugePages: 'Milzu {size} lapas pēc iztukšošanas — brīvas: {free} no {capacity}, rezervei nepieciešams: {reserve}.',
    maintenancePlanActionMigrate: 'migrē',
    maintenancePlanActionMigrateWarning: 'migrē (pārkāpts soft noteikums)',
    maintenancePlanActionStop: 'apstājas',
    maintenancePlanActionBlocked: 'bloķēta',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'tīkla pakalpojums',
    maintenancePlanKindApp: 'App instance',
    maintenancePlanColdMove: 'Aukstā pārvietošana: pods šeit tiek apturēts un nopļauts, un mērķa mezgla worker to izveido no jauna — dīkstāve līdz mērķa workera nākamajam passam.',
    caFingerprint: 'Klastera CA nospiedums',
    staleChip: 'nav aktuāls',
    troubleshootTitle: 'Store problēmu novēršana',
    restartStore: 'Pārstartēt store pakalpojumus',
    restartHint: 'Ja store nepakļaujas, tā pakalpojumi jāpārstartē. Paredzēts pieredzējušiem — jālieto piesardzīgi.',
    restartQueued: 'Pārstartēšanas task ielikts rindā',
    restartError: 'Neizdevās pārstartēt pakalpojumus',
    svcActive: 'aktīvs',
    svcWanted: 'vēlams, nav aktīvs',
    svcStopped: 'apturēts',
    noServices: 'Nav paziņots neviens pakalpojums'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Visa klastera GPU inventārs, grupēts pēc modeļa — pa mezgliem novērotās kartes ar to atzīmētajām reģistrācijām un tagiem',
    usbTitle: 'USB resursi',
    usbSubtitle: 'Visa klastera USB inventārs, grupēts pēc modeļa — pa mezgliem novērotās ierīces ar abu modeļu reģistrācijām (pēc ierīces, pēc porta) un to tagiem',
    markedChip: '{n} lietojamas TVirt',
    orphanChipGpu: '{n} bāreņi',
    orphanChipUsb: '{n} bāreņi',
    colNode: 'Mezgls',
    colRegistration: 'Reģistrācija',
      noRegsHint: 'Nav nevienas reģistrācijas — ierīci atzīmē kā "lietojamu TVirt" mezgla dialogā (Mezgli › mezgls › Iestatījumi).',
      colDevice: 'Ierīce',
      colObserved: 'Novērotās',
      colRegs: 'Reģistrācijas',
      regsNone: 'nav',
      colPci: 'PCIe adrese',
      colIdentity: 'Identitāte / ports',
      colClasses: 'Klases (tagi)',
      colActions: 'Darbības',
      manageOnNode: 'Jāpārvalda mezglā {node} (atzīme mīt mezgla dialogā)',
      introTitle: 'TVirt© lietojamo USB un PCIe ierīču klastera inventārs.',
      introStep1: '1. Mezgli paši atklāj savas GPU un USB ierīces (uzskaite heartbeat ietvaros).',
      introStep2: '2. Ierīci atzīmē kā "lietojamu TVirt" MEZGLA dialogā (Mezgli › mezgls › Iestatījumi) — atzīme to piesaista vfio un reģistrē šeit.',
      introStep3: '3. Šeit reģistrācijām piešķir to KLASES ar tagiem (piem., gpu_class=compute): VM prasības pieprasīs klasi, un plānotājs izvēlēsies mezglu ar brīvu saderīgu ierīci.',
    colMode: 'Režīms',
    colState: 'Stāvoklis',
    colNotes: 'Piezīmes',
    colTags: 'Tagi',
    modeDevice: 'pēc ierīces',
    modePort: 'pēc porta',
    usable: 'lietojama',
    orphanGpu: 'bārenis',
    orphanUsb: 'bārenis',
    hubChip: 'hub',
    orphanPortsTitle: 'Reģistrācijas pēc porta bez pievienotas ierīces — jāpievieno ierīce vai mezglā jānoņem atzīme',
    gpusEmpty: 'Nevienā mezglā vēl nav novērota neviena GPU',
    usbEmpty: 'Nevienā mezglā vēl nav novērota neviena USB ierīce'
  },

  // Iestatījumu formu kopīgais vārdu krājums (pārstrukturēšana 2026-07-24):
  // security lauki baro Klastera lapas karti, mezgla lauki — node-settings lapu;
  // lapa /system/settings, kuras dēļ tie radās, ir mirusi.
  settings: {
    passwordMinLength: 'Paroles minimālais garums',
    sessionIdle: 'Sesijas dīkstāves noildze (minūtēs)',
    lockoutThreshold: 'Bloķēt pēc neizdevušos mēģinājumu skaita',
    lockoutDuration: 'Bloķēšanas ilgums (minūtēs)',
    keyboardLayout: 'Tastatūras izkārtojums',
    keyboardLayoutHint: 'piem., it, en-us — tukšs nozīmē QEMU noklusējumu',
    syslogEndpoint: 'Syslog galapunkts',
    syslogEndpointHint: 'hosts:ports — tukšs atslēdz pārsūtīšanu',
    syslogTls: 'TLS',
    maxQueued: 'Maksimālais task skaits rindā',
    concurrency: 'Worker vienlaicīgums',
    concurrencyHint: 'Worker to piemēro lidojumā',
    notesTitle: 'Piezīmes',
    save: 'Saglabāt',
    saved: 'Iestatījumi saglabāti',
    saveError: 'Neizdevās saglabāt iestatījumus'
  },
  localSettings: {
    derivedChip: 'atvasināts',
    derivedTip: 'Šis device PIEDER fabric derivācijai (H2): redaktors atsakās to aiztikt — mainiet fabric (vai kabeļus) un piemērojiet no jauna, vai paņemiet to atpakaļ zemāk.',
    takeOwnership: 'Pārņemt īpašumā',
    takeOwnershipTitle: 'Pārņemt īpašumā (take-ownership)',
    takeOwnershipConfirm: '{name} pamet fabric bloku un atkal kļūst par MANUĀLU device, ko pārvalda šis redaktors. Mezgls kļūst novirzījies, un nākamais derivācijas apply uz tā atteiks (manualConflict), līdz jūs to pārdēvēsiet vai noņemsiet — vai izlabosiet fabric.',
    nodeSettingsTitle: 'Mezgla iestatījumi',
    nodeSettingsSubtitle: 'Tas, ko šis mezgls piemēro — task rinda, konsole, žurnālu pārsūtīšana — plus tā tagi un piezīmes',
    baseTitle: 'Hosta rezerves (TVirt Proximity)',
    baseSubtitle: 'CPU un RAM, kas rezervētas hosta operētājsistēmai — empīriskās kapacitātes ievaddati, ar kuriem Proximity izvieto VM',
    baseMemory: 'Pamata RAM (MiB)',
    baseMemoryHint: 'Novērotais kopapjoms: {total} MiB. VM lietojamais = kopapjoms − pamats − šeit izvietoto ieslēgto VM RAM.',
    baseMemoryHintNoTotal: 'VM lietojamais = novērotais kopapjoms − pamats − šeit izvietoto ieslēgto VM RAM.',
    baseCpu: 'Pamata CPU kodoli',
    baseCpuHint: 'Novērotās loģiskās CPU: {total}. Izmantoti tikai kā ranžēšanas svars — vCPU overcommit ir normāls.',
    baseCpuHintNoTotal: 'Izmantoti tikai kā ranžēšanas svars — vCPU overcommit ir normāls.',
    baseHint: 'RAM ir stingrais uzņemšanas slieksnis: VM, kas neietilpst lietojamajā RAM, tiek atteikta ar runīgu kļūdu. Uz hostiem, kas mitina store dalībniekus vai Ceph dēmonus, pamats jāpaaugstina.',
    placementTitle: 'Fiziskais izvietojums',
    placementSubtitle: 'Kur fiziski atrodas šis serveris — deklarēts vienu reizi, lai kam tas noderētu',
    placementHint: 'Izvietojums vada CRUSH hierarhiju katram Ceph klasterim, kuram uz šī servera ir OSD: izmaiņu saglabāšana ar task pārkārto to kartes (host → rack → … → root). Daļējas deklarācijas ir likumīgas — tukšie līmeņi sabrūk. Nosaukumi ir kopīgi visā kartē: divi serveri vienā un tajā pašā rack deklarē vienu un to pašu rack nosaukumu.',
    placementNameInvalid: 'DNS drošs nosaukums (mazie burti, cipari, defises)',
    placementEmpty: 'Tukšs = nav deklarēts',
    placementLevel: {
      chassis: 'Korpuss',
      rack: 'Rack',
      row: 'Rinda',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Telpa',
      datacenter: 'Datu centrs',
      zone: 'Zona',
      region: 'Reģions'
    },
    cablingTitle: 'Kabelējums',
    cablingSubtitle: 'Pie kura switch porta ir pieslēgta katra saskarne — deklarācija mīt mezglā (Annex O.9)',
    cablingHint: 'Viens kabelis katrai NIC, viens kabelis katram portam visā flotē (API atsaka, nosaucot īpašnieku). Kabelēt uz portu, kas ir LAGG dalībnieks, ir likumīgi — tas ir bond gadījums: nākotnes atvasināšana to atveidos kā LACP.',
    cablingInterface: 'Saskarne',
    cablingNotCabled: '— nav pieslēgta —',
    cablingNoInterfaces: 'Nav novērota neviena tīkla saskarne',
    disksTitle: 'Diski',
    disksSubtitle: 'Novērotās bloku ierīces — viena skenēšana katrā saskaņošanas ciklā; šeit atzīmē diskus, kas lietojami kā Ceph OSD (N.15: piemērotība ir eksplicīta)',
    colDataDisk: 'Datu disks',
    dataDisksHint: 'Atzīmējot ierīci, tā tiek deklarēta par lietojamu OSD; sērijas numurs ir tās identitātes tapa — nokopēts no aparatūras, ja disks to paziņo, citādi izkalts (tvirt-…). Ceph reģistrācijas dialogs piedāvā tikai deklarētos diskus.',
    diskDeclaredSerial: 'deklarēts',
    diskNotObserved: 'deklarēts, bet nav novērots — ierīce jāpieslēdz atpakaļ vai jānoņem atzīme',
    noDisks: 'Vēl nav novērota neviena bloku ierīce',
    colSerial: 'Sērijas numurs',
    colModel: 'Modelis',
    colSize: 'Izmērs (GiB)',
    colDiskType: 'Tips',
    colInUse: 'Lietošanā',
    colObservedAt: 'Novērots',
    diskInUse: 'lietošanā',
    diskFree: 'brīvs',
    diskMounted: 'montēts',
    diskPartitions: 'nodalījumi',
    passthroughTitle: 'Passthrough ierīces',
    passthroughSubtitle: 'Novērotās GPU un USB ierīces — šeit atzīmē, ko TVirt drīkst padot VM; atzīme reģistrē ierīces identitāti (kārta U1+G1)',
    passthroughHint: 'Atzīme reģistrē ierīci (stabils id — tagu un klases prasību target). Atzīmētai GPU VISA IOMMU grupa tiek piesaistīta vfio-pci vienā gabalā — tā uzreiz pamet hostu; atzīmes noņemšana atgriež natīvo draiveri. USB pastāv abi ratificētie modeļi: pēc ierīces (vendor+produkts, lai kur tā būtu iesprausta) un pēc fiziskā porta (VM nonāk viss, kas tajā iesprausts). USB pie atzīmēšanas bind nenotiek — attach notiek VM izpildlaikā.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'TVirt lietojama',
    colGpu: 'GPU',
    colPciAddress: 'PCI adrese',
    colDriver: 'Draiveris',
    colVerdict: 'Spriedums',
    gpuEligible: 'Piemērota',
    gpuIneligible: 'Nav piemērota',
    gpuReason: {
      'no-iommu': 'IOMMU uz hosta nav aktīvs',
      'group-spans-slots': 'IOMMU grupa nav izolēta: tā stiepjas pāri citiem slotiem',
      'multiple-display': 'IOMMU grupa nav izolēta: vairāk nekā viena video funkcija',
      'foreign-function': 'IOMMU grupa nav izolēta: tajā ir sveša funkcija'
    },
    vfioNotReady: 'IOMMU uz šī hosta nav aktīvs: neviena GPU nav piemērota, kamēr to nav ieslēgusi hosta platforma (OEM ISO) — TVirt izpildlaikā nekad neaiztiek kodola argumentus.',
    vfioMissingKernelArg: 'IOMMU uz šī hosta nav aktīvs: programmaparatūra ziņo par VT-d/AMD-Vi (ACPI tabula DMAR/IVRS ir klāt), taču trūkst kodola argumenta — kodola komandrindai jāpievieno intel_iommu=on (Intel) vai jānoņem amd_iommu=off (AMD) un jāpārstartē. TVirt izpildlaikā nekad neaiztiek kodola argumentus.',
    vfioFirmwareDisabled: 'IOMMU uz šī hosta nav aktīvs: VT-d/AMD-Vi ir atslēgts programmaparatūrā (nav ACPI tabulas DMAR/IVRS) vai arī CPU to neatbalsta — tas jāieslēdz programmaparatūras iestatījumos, neviens kodola arguments to ieslēgt nespēj. TVirt izpildlaikā nekad neaiztiek hostu.',
    gpuBindError: 'vfio-pci bind neizdevās uz {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Ugunsmūris uz nepārvaldītiem bridge',
    firewallBridgesSubtitle: 'Uz šī mezgla ar roku būvētie bridge, kuru uzstādījums piekrīt TVirt renderētajām ugunsmūra chain uz pievienotajām viesu NIC',
    firewallBridgesHint: 'TVirt nekad neaiztiek svešo bridge — chain noenkurojas uz tap/veth, kas vienmēr pieder TVirt. Saraksts ir piekrišanas vārti: default-deny un anti-spoof var salauzt to, ko manuāls uzstādījums sagaida, tāpēc NIC ar ugunsmūri uz nepārvaldīta bridge, kas ŠEIT nav uzskaitīts, tiek noraidīta ar runājošu kļūdu.',
    firewallBridgesEmpty: 'Neviens nepārvaldīts bridge uz šī mezgla nepiekrīt TVirt renderētajām ugunsmūra chain.',
    firewallBridgeAdd: 'Pievienot bridge',
    firewallBridgeInvalid: 'Nav Linux saskarnes nosaukums (1-15 rakstzīmes, bez slīpsvītras un atstarpēm)',
    firewallBridgeDuplicate: 'Nosaukums jau ir sarakstā',
    colMarkDevice: 'Pēc ierīces',
    colMarkPort: 'Pēc porta',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Ports',
    passthroughOrphan: 'bārenis — reģistrēts, bet vairs netiek atklāts: jāpieslēdz atpakaļ vai jānoņem atzīme',
    noGpus: 'Vēl nav novērota neviena GPU',
    noUsb: 'Vēl nav novērota neviena USB ierīce',
    networkGeneration: 'Tīkla paaudze',
    applied: 'Piemērota',
    converged: 'saskaņots',
    behind: 'atpaliek — {m} / {n}',
    notConfigured: 'nav konfigurēts',
    rollbackBody: 'Neizdevās piemērot {gen} paaudzi: {error}',
    rolledBackChip: 'veikts rollback',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Pārvaldīto NIC reģistrs — reģistrācija IR pārvaldības deklarācija: reģistrēta NIC bez konfigurācijas netiek aiztikta (clear-if to skaidri pasludina par tīru), nereģistrēta ierīce netiek aiztikta nekad',
    addNic: 'Reģistrēt NIC',
    addNicTitle: 'Reģistrēt NIC (add-nic)',
    delNic: 'Beigt pārvaldību',
    delNicTitle: 'Beigt pārvaldību (del-nic)',
    delNicConfirm:
      '{name} pārvaldība beidzas: reģistra ieraksts un tā konfigurācija tiek dzēsti, un TVirt profils noņemts — ierīce paliek tāda, kādu to atstājis Linux.',
    nicName: 'Ierīces nosaukums',
    nicMac: 'Pastāvīgā MAC adrese',
    nicMacHint: 'pastāvīgais aparatūras MAC — stabilā identitāte, ko fiksē TVirt Server Installer',
    colObserved: 'Novērota',
    nicObserved: 'novērota',
    nicNotObserved: 'nav novērota',
    nicMacMismatch: 'MAC atšķiras — novērots {mac}',
    noNics: 'Nav reģistrēta neviena NIC — jāreģistrē ierīce, lai sāktu to pārvaldīt',
    noManagedDevices: 'Nav nevienas pārvaldītas ierīces — vispirms jāreģistrē NIC, viss tiek būvēts uz reģistra',
    inventoryTitle: 'Novērotās ierīces',
    inventorySubtitle: 'Atjauninātas katrā mezgla worker saskaņošanas ciklā — validācija pārbauda ierīču nosaukumus pret šo inventāru',
    colDevice: 'Ierīce',
    colType: 'Tips',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Ātrums',
    colTopology: 'Topoloģija',
    colMtu: 'MTU',
    colAddresses: 'Adreses',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP neagregē',
    noInventory: 'Neviena ierīce līdz šim nav paziņota',
    interfacesTitle: 'Saskarnes',
    interfacesSubtitle:
      'Reģistrēto NIC un deklarēto loģisko ierīču L3 konfigurācija — set-if aizstāj visu bloku, edit-if pielabo īpašības, clear-if to iztukšo (eksplicīta tīrīšana)',
    colConfig: 'Vēlamā konfigurācija',
    clean: 'tīra',
    setIf: 'Mainīt adresāciju',
    setIfTitle: 'Mainīt adresāciju (set-if)',
    editIf: 'Mainīt īpašības',
    editIfTitle: 'Mainīt īpašības (edit-if)',
    clearIf: 'Iztukšot konfigurāciju',
    clearIfTitle: 'Iztukšot konfigurāciju (clear-if)',
    clearIfConfirm: 'Saskarnes konfigurācija tiek iztukšota. Tīra saskarne ir priekšnosacījums, lai to pakļautu kā bond/bridge dalībnieku vai VLAN vecāku.',
    ip4Mode: 'IPv4 režīms',
    ip6Mode: 'IPv6 režīms',
    modeUnconfigured: 'Nav konfigurēta',
    modeStatic: 'Statiska',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 adreses',
    ip6Addresses: 'IPv6 adreses',
    addressesHint: 'CIDR, atdalīti ar komatu',
    gw4: 'IPv4 vārteja',
    gw6: 'IPv6 vārteja',
    dns: 'DNS serveri',
    dnsHint: 'atdalīti ar komatu — tukšs nodzēš DNS (set-if aizstāj bloku)',
    routes4: 'IPv4 statiskie maršruti',
    routes6: 'IPv6 statiskie maršruti',
    routeTo: 'Galamērķis (CIDR)',
    routeVia: 'Caur',
    addRoute: 'Pievienot maršrutu',
    routesChip: 'maršruti',
    mtu: 'MTU',
    mtuHint: 'tukšs = draivera noklusējums',
    vlansTitle: 'VLAN',
    addVlan: 'Pievienot VLAN',
    addVlanTitle: 'Pievienot VLAN (add-vlan)',
    delVlanTitle: 'Dzēst VLAN (del-vlan)',
    vlanParent: 'Vecāka saskarne',
    vlanId: 'VLAN ID',
    vlanPreview: 'Ierīces nosaukums',
    colParent: 'Vecāks',
    colVlanId: 'ID',
    noVlans: 'Nav deklarēts neviens VLAN',
    bondsTitle: 'Bond',
    addBond: 'Pievienot bond',
    addBondTitle: 'Pievienot bond (add-bond)',
    editBondTitle: 'Rediģēt bond',
    editBond: 'Saglabāt bond',
    delBondTitle: 'Dzēst bond (del-bond)',
    bondName: 'Bond nosaukums',
    members: 'Dalībnieki',
    membersHint: 'dalībniekiem jābūt tīrām saskarnēm (bez L3 konfigurācijas)',
    bondMode: 'Režīms',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primārais dalībnieks',
    rate: 'LACP rate',
    hash: 'Pārraides hash politika',
    colMembers: 'Dalībnieki',
    colMode: 'Režīms',
    noBonds: 'Nav deklarēts neviens bond',
    bridgesTitle: 'Bridge',
    addBridge: 'Pievienot bridge',
    addBridgeTitle: 'Pievienot bridge (add-bridge)',
    editBridgeTitle: 'Rediģēt bridge',
    editBridge: 'Saglabāt bridge',
    delBridgeTitle: 'Dzēst bridge (del-bridge)',
    bridgeName: 'Bridge nosaukums',
    stp: 'STP',
    stpOn: 'STP ieslēgts',
    stpOff: 'STP izslēgts',
    colStp: 'STP',
    noBridges: 'Nav deklarēts neviens bridge',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Iestatīt hostname',
    setHostnameTitle: 'Iestatīt hostname (set-hostname)',
    hostnameHint: 'Tikai OS identitāte — mezgla nosaukums klasterī netiek aiztikts',
    notSet: 'nav iestatīts',
    staticHostsTitle: 'Statiskie host ieraksti',
    addStaticHost: 'Pievienot ierakstu',
    addStaticHostTitle: 'Pievienot statisku host ierakstu',
    delStaticHostTitle: 'Dzēst statisku host ierakstu',
    hostIp: 'IP adrese',
    hostNames: 'Nosaukumi',
    hostNamesHint: 'atdalīti ar komatu vai atstarpi',
    colIp: 'IP',
    colNames: 'Nosaukumi',
    noStaticHosts: 'Nav neviena statiska host ieraksta',
    delConfirm: '{name} noņemšana no vēlamā dokumenta — mezgla worker konverģē ar NetworkManager kontrolpunktu un automātisku rollback.',
    remove: 'Noņemt',
    opError: 'Tīkla operācija tika noraidīta'
  }
}
